import { Reveal } from "./Reveal";

const STATS = [
  { value: "10+", label: "Years of frantiger legacy", testId: "stat-legacy-years-badge" },
  { value: "100+", label: "Years combined consulting experience", testId: "stat-combined-experience-badge" },
  { value: "100+", label: "Angel & seed investors in network", testId: "stat-investor-network-badge" },
  { value: "₹0", label: "Setup friction for partner colleges", testId: "stat-zero-setup-badge" },
];

const Legacy = () => (
  <section id="legacy" className="bg-white py-24 lg:py-32 border-b border-[#E2E8F0]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-6">
          <Reveal>
            <span className="font-mono-x text-xs uppercase tracking-[0.25em] text-[#0055FF]">
              / THE FRANTIGER ADVANTAGE
            </span>
            <h2 className="mt-5 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#0A0D14] leading-tight">
              A decade of frantiger<sup className="font-mono-x text-xs">®</sup>.{" "}
              <span className="font-serif-accent text-[#0055FF]">A century of combined wisdom.</span>
            </h2>
            <p className="mt-6 text-base text-[#64748B] leading-relaxed max-w-lg">
              Every consultant on the frantiger team brings their own hard-earned
              years in the field — strategy, finance, brand, GTM, fundraising.
              Combined, that crosses <span className="text-[#0A0D14] font-semibold">100 years of consulting
              experience</span>, now pointed at one mission: making your campus a
              launchpad for real ventures, not just resume lines.
            </p>
            <p className="mt-4 text-base text-[#64748B] leading-relaxed max-w-lg">
              We don't lecture. We sit with your students, stress-test their ideas,
              open our investor network, and stay until the first cheque clears.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
            {STATS.map((s, i) => (
              <Reveal key={s.testId} delay={i * 0.08} className="bg-white">
                <div data-testid={s.testId} className="p-6 lg:p-8 group hover:bg-[#EBF2FF] transition-colors">
                  <div className="font-display font-black text-3xl lg:text-5xl text-[#0055FF] tracking-tight" style={{ fontWeight: 900 }}>
                    {s.value}
                  </div>
                  <div className="mt-2 font-mono-x text-[11px] uppercase tracking-[0.15em] text-[#64748B] leading-relaxed">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 lg:sticky lg:top-28">
          <Reveal delay={0.15}>
            <div className="relative border border-[#0055FF]/25">
              <div className="flex items-center justify-between px-4 py-2.5 border-b border-[#0055FF]/20 bg-white">
                <span className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-[#0055FF]">
                  FIG.02 — THE WAR ROOM
                </span>
                <span className="font-mono-x text-[10px] text-[#64748B]">EST. LEGACY / 10 YRS</span>
              </div>
              <div className="overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?q=85&w=1400&auto=format&fit=crop"
                  alt="Indian consulting team in a strategy session with venture builders"
                  className="w-full h-[320px] sm:h-[420px] object-cover transition-transform duration-700 hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="px-4 py-3 bg-[#0A0D14] flex items-center justify-between">
                <span className="font-mono-x text-[10px] uppercase tracking-[0.2em] text-white/70">
                  100+ combined years, in the room with your students
                </span>
                <span className="w-2 h-2 bg-[#0055FF] animate-pulse-dot" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Legacy;
